<template>
  <span
    class="standard-stars"
    :aria-label="'Standard ' + getIle()"
    role="img"
    v-if="getIle() > 0"
  >
    <a-icon
      aria-hidden="true"
      type="star"
      theme="filled"
      v-for="n in getIle()"
      :key="n"
    />
  </span>
</template>

<script>
export default {
  props: {
    starSize: Number,
    number: String,
  },
  data: () => ({
    ile: 0,
  }),
  methods: {
    getIle() {
      this.ile = Math.floor(Number(this.number) / 10);
      return this.ile;
    },
  },
  mounted() {
    this.getIle();
  },
};
</script>

<style lang="scss" scoped>
.standard-stars {
  white-space: nowrap;

  > i:not(:last-of-type) {
    margin-right: 3px;
  }
}
</style>
